<div class="criterion-row-container" cdkDrag cdkDragBoundary=".rules-list" cdkDragLockAxis="y">
    <div [class]="tabClass()">
        @if (displayIndex()) {
            {{ index() + 1 }}
        }
    </div>
    <div class="criterion-container">
        <div class="criterion-content">
            <div class="criterion-type-badge">
                <fa-icon [icon]="faMagnifyingGlass" />
                {{ type }}
            </div>
            <div class="web-search-row">
                <div class="web-search-typeahead-container">
                    <r1-compass-lib-typeahead-search
                        [valueFormControl]="criterionForm.controls.searchTerm"
                        [displayFormControl]="criterionForm.controls.searchTerm"
                        [resultDisplayPropertyPath]="'display'"
                        [resultValuePropertyPath]="'value'"
                        [disabled]="false"
                        [searchResults]="typeaheadResults"
                        (search)="onValueTypeahead($event)" />
                </div>
                <mat-form-field class="startdate-form-field">
                    <mat-label>Select a start date</mat-label>
                    <input
                        matInput
                        readonly
                        [matDatepicker]="datePicker1"
                        [formControl]="criterionForm.controls.startDate"
                        (click)="datePicker1.open()"
                        (dateInput)="onDateInput($event, criterionForm.controls.startDate)" />
                    <fa-icon matSuffix class="picker-icon" [icon]="faCalendar" (click)="datePicker1.open()" />
                    <mat-datepicker #datePicker1 />
                    @if (criterionForm.controls.startDate) {
                        <mat-error>Value required</mat-error>
                    }
                </mat-form-field>
                <mat-form-field class="enddate-form-field">
                    <mat-label>Select an end date</mat-label>
                    <input
                        matInput
                        readonly
                        [matDatepicker]="datePicker2"
                        [formControl]="criterionForm.controls.endDate"
                        (click)="datePicker2.open()"
                        (dateInput)="onDateInput($event, criterionForm.controls.endDate)" />
                    <fa-icon matSuffix class="picker-icon" [icon]="faCalendar" (click)="datePicker2.open()" />
                    <mat-datepicker #datePicker2 />
                    @if (criterionForm.controls.endDate) {
                        <mat-error>Value required</mat-error>
                    }
                </mat-form-field>
            </div>
        </div>
        <div class="criterion-options-container">
            @if (deletable()) {
                <div
                    class="trash-icon-container"
                    role="button"
                    aria-disabled="true"
                    (click)="onDelete()"
                    (keydown)="onDelete()">
                    <fa-icon [icon]="faTrash" />
                </div>
            } @else {
                <div class="empty-icon-container"></div>
            }
        </div>
    </div>
</div>
